<div id="hide-menu" class="btn-header cursor-pointer">
        <span> <a (click)="onToggle()" title="{{'common_all_header_icon_cart_collapse'| i18n}}"><i
                class="fa fa-reorder"></i></a> </span>
</div>